/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_Content_FieldInputs */

const en_admin_posts_content_field = /** @type {(inputs: Admin_Posts_Content_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content`)
};

const zh_admin_posts_content_field = /** @type {(inputs: Admin_Posts_Content_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正文`)
};

/**
* | output |
* | --- |
* | "Content" |
*
* @param {Admin_Posts_Content_FieldInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_posts_content_field = /** @type {((inputs?: Admin_Posts_Content_FieldInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_Content_FieldInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_posts_content_field(inputs)
	return zh_admin_posts_content_field(inputs)
});
export { admin_posts_content_field as "admin.posts.content_field" }